import parsePhoneNumber from "libphonenumber-js";

export function formattedPhoneNumber(phoneNumber: string | undefined) {
    if (!phoneNumber || phoneNumber === '') return '';
    return parsePhoneNumber(phoneNumber, 'DE')?.getURI();
}